import React from "react";
import { useNavigate } from "react-router-dom";
import { Rocket } from "lucide-react";
import { LanguageCode } from "../../utils/translations";
import { HOME_COPY } from "./homeContent";
import { HOME_THEME, primaryBtn } from "./theme";

interface FinalCTAProps {
  lang: LanguageCode;
}

const FinalCTA: React.FC<FinalCTAProps> = ({ lang }) => {
  const c = HOME_COPY[lang].finalCta;
  const navigate = useNavigate();

  return (
    <section style={{ padding: "34px 5%", background: HOME_THEME.surface }}>
      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          background: `linear-gradient(135deg, ${HOME_THEME.primaryDark}, ${HOME_THEME.primary})`,
          borderRadius: "20px",
          padding: "32px 5%",
          textAlign: "center",
          color: "#fff",
          boxShadow: "0 30px 60px -25px rgba(1,126,132,0.6)",
        }}
      >
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(255,255,255,0.15)",
            padding: "6px 14px",
            borderRadius: "999px",
            fontSize: "0.8rem",
            fontWeight: 700,
            marginBottom: "12px",
          }}
        >
          <Rocket size={14} /> {c.badge}
        </div>
        <h2 style={{ fontSize: "1.8rem", fontWeight: 900, margin: "0 0 8px 0" }}>
          {c.title}
        </h2>
        <p
          style={{
            fontSize: "1rem",
            opacity: 0.92,
            maxWidth: "560px",
            margin: "0 auto 18px",
            lineHeight: 1.5,
          }}
        >
          {c.subtitle}
        </p>
        <button
          style={{ ...primaryBtn, background: "#fff", color: HOME_THEME.primaryDark }}
          onClick={() => {
            const el = document.getElementById("contact");
            if (el) el.scrollIntoView({ behavior: "smooth" });
            else navigate("/#contact");
          }}
        >
          {c.button}
        </button>
      </div>
    </section>
  );
};

export default FinalCTA;
